import { DateTime } from '@packages/components/date-time/date-time';
import { NoDataEnDash } from '@packages/components/no-data-en-dash/no-data-en-dash';
import type { GridRenderCellParams } from '@packages/fenrir/components';

export const DateTimeCell = (params: GridRenderCellParams) => {
  return params.value ? <DateTime value={params.value} /> : <NoDataEnDash />;
};
